function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", null, React.createElement("path", {
  d: "M742.216,326.415L640,272.339v-61.005c0-6.21-3.44-11.844-8.966-14.679l-119.5-61.333 c-4.711-2.418-10.27-2.432-14.993-0.039l-110.5,56C380.501,194.089,377,199.79,377,206v61.577l-111.216,58.838 C260.387,329.271,257,334.894,257,341v478h6.251l-0.001,0.25L504,819V237.723l214,113.214V812h33V341 C751,334.894,747.613,329.271,742.216,326.415z M467,585.334l-172,92v-50l172-92V585.334z M467,415.333l-172,92v-50l172-92 V415.333z M502.727,201.063L410,250.119v-33.983l93.952-47.614L607,221.411v33.469l-102.951-54.465L504,200.507v-0.174 L502.727,201.063z"
}), React.createElement("polygon", {
  points: "533,585.334 695,669.334 695,619.334 533,535.334 \t\t"
}), React.createElement("polygon", {
  points: "533,415.333 695,499.334 695,449.333 533,365.333 \t\t"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-moja-firma.4eac6368.svg";
export { SvgComponent as ReactComponent };